import { z } from 'zod';
import { tenantStatusSchema } from '../../common/schemas/enum.schemas.js';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
/** The tenant the signed-in session belongs to. Further tenants are created by `scripts/seed-tenant.ts`. */
export const tenantSchema = z.object({
    id: uuidSchema,
    code: z.string().min(1),
    name: z.string().min(1),
    timezone: z.string().min(1),
    currency: z.string().min(1),
    status: tenantStatusSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=tenant.schemas.js.map